import { useRotationStore } from 'src/context/RotationContext';
import { useStowageStore } from 'src/context/StowageContext';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { getTankContentForCondition } from 'src/utils/stowage/manifest/tankPlanConditionUtils';
import { getAllTanks } from 'src/utils/stowage/tankPlanUtils';

export const useSelectCargoOperation = () => {
    const { setSelectedCargoOperation, setSelectedTanks } = useStowageSelectionStore();
    const { selectedStowageRotationPortCall, selectedStowageRotationBerthCall } = useRotationStore();
    const { activeStowagePlan, tankPlan, selectedTankPlanCondition } = useStowageStore();

    const selectCargoOperation = (cargoOperation: RotationCargoOperation) => {
        setSelectedCargoOperation({ ...cargoOperation });
        const allTanks = getAllTanks(tankPlan);
        const _selectedTanks = allTanks.filter((tank) => {
            const tankContent = getTankContentForCondition(
                activeStowagePlan,
                selectedStowageRotationPortCall,
                selectedStowageRotationBerthCall,
                selectedTankPlanCondition,
                tank
            );
            return tankContent?.cargoContents?.some((c) => c.cargo.cargoGuid === cargoOperation.cargoGuid);
        });
        setSelectedTanks([..._selectedTanks]);
    };
    return { selectCargoOperation };
};
